import { render, staticRenderFns } from "./LogIntegracaoSuportePos.vue?vue&type=template&id=1139b2da&"
import script from "./LogIntegracaoSuportePos.vue?vue&type=script&lang=js&"
export * from "./LogIntegracaoSuportePos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports